import React, { useState, useEffect } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const SnackbarCookies = (props) => {
  const [showSnackbar, setShowSnackbar] = useState(false);

  useEffect(() => {
    // Check if WordPress cookie exists
    const wordpressCookieExists = document.cookie.split(';').some((item) => item.trim().startsWith('visited_before='));

    // If WordPress cookie doesn't exist, show Snackbar
    if (!wordpressCookieExists) {
      setShowSnackbar(true);
    }
  }, []);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setShowSnackbar(false);

    // Set the cookie to true when the Snackbar is closed
    if (!document.cookie.split(';').some((item) => item.trim().startsWith('visited_before='))) {
      // Set the cookie for 365 days if it doesn't exist
      const date = new Date();
      date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
      const expires = "; expires=" + date.toUTCString();
      document.cookie = "visited_before=true" + expires + "; path=/";
    }
  };

  return (
    <Snackbar open={showSnackbar} autoHideDuration={6000} onClose={handleClose}>
      <Alert onClose={handleClose} severity="info">
        This website uses cookies to improve user experience. By continuing to use this site, you accept our use of
        cookies.
      </Alert>
    </Snackbar>
  );
}

export default SnackbarCookies;
